import { render } from "./RatingBarRank113.vue?vue&type=template&id=c87ec136&scoped=true"
const script = {}

import "./RatingBarRank113.vue?vue&type=style&index=0&id=c87ec136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87ec136"]])

export default __exports__